import React, { Dispatch, MouseEvent } from 'react';
import { NavigateFunction } from 'react-router';
import { ResizeCallbackData } from 'react-resizable';
import { Dropdown, Menu, Checkbox, Spin, Popover } from 'antd';
import { Field as FieldReact } from 'react-final-form';
import { LoadingOutlined } from '@ant-design/icons';
import { IBreadcrumbItem } from 'Components/UI/BreadCrumb';
import {
  ListagemArquivosActions,
  ListagemArquivosActionUnion,
} from 'Store/ListagemArquivos/ListagemArquivos.actions';
import { ColumnProps } from 'antd/lib/table';
import { Icon } from 'Components/UI';
import Field from 'Components/UI/Field';
import { INomenclatureData } from 'Data/interfaces/Nomenclatura/INomenclatureData';
import { iconFileByExtension } from 'Utils/Icons';
import i18next from 'i18next';
import {
  IFileData,
  getFileStatusEnumLabel,
  FileStatusEnumColor,
  IBreadCrumbItem,
  FileStatusEnum,
} from 'Data/interfaces/ListagemArquivos/IListFilesResponse';
import { fileDataSizeToBytes, sizeFileToInitials } from 'Utils/toolBox';
import FilterModal from './Modals/FilterModal';
import Tooltip from 'Components/UI/Tooltip';
import {
  setTag,
  openFolder,
  getFilterOptions,
  getSecondPlanUploadFiles,
  getOrderTitle,
} from './ListagemArquivos.helpers';
import { IListagemArquivosFilters } from 'Store/ListagemArquivos/interfaces/IListagemArquivosState';
import { IObraData } from 'Data/interfaces/Obra/IObraData';
import { IBreadCrumbItem as IBreadCrumbItemResponse } from 'Data/interfaces/ListagemArquivos/IListFilesResponse';
import { GetAvatar } from 'Utils/generateThumbnail';
import { datetimeToString, dateToLocaleString } from 'Utils/DateUtils';
import toastHandler from 'Utils/toastHandler';
import AccessPermission from 'Utils/AcessPermission';
import { allOtherExtensions } from 'Utils/ViewerUtils';
import { IOpenMoreActionsDropdown } from '.';
import EdicaoNomenclatura from './Components/EdicaoNomenclatura/EdicaoNomenclatura';
import { ISharedUser } from 'Data/interfaces/User/ISharedUser';
import InfoRender from 'Components/UI/InfoRender';
import InfoQRCodeDropdown from './Components/InfoQRCodeDropdown';
import Button from 'Components/UI/Button';
import NewEdicaoNomenclatura from './Components/NewEdicaoNomenclatura/NewEdicaoNomenclatura';
import { INotificationInAppObra } from 'Data/interfaces/Notification/INotification';
import { DotNotification } from 'Components/UI/Dot';
import MoreActionsDropdownContent from './Components/MoreActionsDropdownContent';
import { IListFilesOrder, IListFilesOrderKey } from 'Data/interfaces/ListagemArquivos/ISortListFiles';
import ResizableColumnHeader from 'Components/UI/Table/ResizableColumnHeader';
import styles from './ListagemArquivos.module.scss';

export interface IResizableColumnProps {
  active: boolean;
  columnWidth: Record<string, number>;
};

export const RESIZABLE_COLUMN_IDS: Record<string, string> = {
  Name: 'name',
  Extension: 'extension',
  SizeInBytes: 'size-in-bytes',
  RenderingStatus: 'rendering-status',
  Versions: 'versions',
  LastUpdate: 'last-update',
  Status: 'status',
  Action: 'action',
};

export interface IColumnsInput {
  columnsWidth: IResizableColumnProps['columnWidth'];
  fileList: IFileData[];
  filters: IListagemArquivosFilters;
  breadCrumbItem: IBreadCrumbItem;
  constructionSiteId: number;
  folderId: string;
  ConstructionSiteDisciplinesId: number;
  constructionSiteApiId: number;
  itemsNotification: Array<string | null>;
  itemIdNotification: Array<string | null>;
  planFree?: boolean;
  goRender?: boolean;
  disciplineName?: string | null;
  showModalLimitRenderFiles?: boolean;
  activeRow: string[];
  openLink: string;
  isCoordly2DViewerEligible: (fileExtension: string) => boolean;
  isCoordly3DViewerEligible: (fileExtension?: string, sizeInBytes?: number) => boolean;
  isLoadingFilesObsoleteList?: boolean;
  currentUserPrivileges?: ISharedUser;
  isObsoleteFolder?: boolean;
  notificationsObj: {
    foldersIds: string[];
    notificationsMap: Record<string, INotificationInAppObra[]>;
  };
  isLoadingRenameFile: boolean;
  openMoreActionsDropdown: IOpenMoreActionsDropdown;
  preferencesFeature: boolean;
  order: IListFilesOrder;
  breadCrumbPreviousItemId: string | null;
  dispatch: Dispatch<ListagemArquivosActionUnion>;
  navigate: NavigateFunction;
  onChangeNomenclatureInList: (record: any) => void;
  onOpenHistoryDrawer: (fileData?: IFileData | null) => void;
  onOpenMoreActionsDropdown: (id: string, open: boolean) => void;
  onCloseMoreActionsDropdown: () => void;
  onContextMenu: (e: MouseEvent, record: IFileData) => void;
  onToggleContextMenuPreventClose: (value: boolean) => void;
  onOpenFile: (file: IFileData | null, event: number) => void;
  onToggleFollowFolder: (files: IFileData[]) => void;
  onDownloadFile: (file: IFileData | null) => void;
  onEditFile: (file: IFileData | null) => void;
  onChangeStatusFile: (
    file: IFileData | null,
    status: FileStatusEnum,
    onClose: () => void,
  ) => void;
  onOpenModalExclusaoArquivos: (file?: IFileData | null) => void;
  onSortList: (key: IListFilesOrderKey) => void;
  onResize: (columnId: string, data: ResizeCallbackData) => void;
}

export interface IEditColumnsInput {
  editFormIndex: number[];
  isLoadingRenameFile: boolean;
  nomenclature: INomenclatureData;
  obra: IObraData;
  constructionSiteDisciplinesId: number;
  isStageValidation?: boolean;
  onSubmit: (values: any) => void;
  dispatch: Dispatch<ListagemArquivosActionUnion>;
}

export interface IRequestPlotColumnsInput {
  fileList: IRequestPlotColumns[];
  dispatch: Dispatch<ListagemArquivosActionUnion>;
  deleteRow: (index: number) => void;
  onChangeQtyValue: (value: number, index: number) => void;
  onChangeHasColor: (e: any) => void;
  onChangeAllHasColor: (e: any) => void;
  onChangeShowQRCode: (e: any) => void;
  onChangeAllShowQRCode: (e: any) => void;
}

export interface IRequestPlotColumns {
  Name: string;
  QtyCopies?: number;
  HasColor?: boolean;
  IsFolder?: boolean;
  Extension?: string;
  key: number;
  FileInfoFk?: number | null;
  FileApiId?: string | null;
  ShowQRCode?: boolean;
}

export const getColumnsTable: (input: IColumnsInput) =>
  Array<ColumnProps<IFileData>> = ({
    columnsWidth,
    fileList,
    filters,
    breadCrumbItem,
    constructionSiteId,
    folderId,
    constructionSiteApiId,
    activeRow,
    isLoadingRenameFile,
    openLink,
    isCoordly2DViewerEligible,
    isCoordly3DViewerEligible,
    disciplineName,
    isLoadingFilesObsoleteList,
    currentUserPrivileges,
    isObsoleteFolder,
    ConstructionSiteDisciplinesId,
    notificationsObj,
    openMoreActionsDropdown,
    preferencesFeature,
    order,
    breadCrumbPreviousItemId,
    dispatch,
    navigate,
    onChangeNomenclatureInList,
    onOpenHistoryDrawer,
    onOpenMoreActionsDropdown,
    onCloseMoreActionsDropdown,
    onContextMenu,
    onSortList,
    onOpenFile,
    onToggleFollowFolder,
    onDownloadFile,
    onEditFile,
    onChangeStatusFile,
    onToggleContextMenuPreventClose,
    onOpenModalExclusaoArquivos,
    onResize,
  }) => ([
    {
      dataIndex: 'Name',
      className: `${styles['columnNome']} ${preferencesFeature ? styles['columnNomePointer'] : ''}`,
      title: (
        <ResizableColumnHeader
          columnId={RESIZABLE_COLUMN_IDS.Name}
          title={'Nome'}
          width={columnsWidth[RESIZABLE_COLUMN_IDS.Name]}
          height={38}
          sorter={() => onSortList('name')}
          orderTooltip={getOrderTitle(order.name, 'name')}
          onResize={onResize}
        />
      ),
      width: columnsWidth[RESIZABLE_COLUMN_IDS.Name],
      render: (text: string, record: any, index: number) => {
        const hasNotification = notificationsObj?.notificationsMap?.hasOwnProperty(record.Identifier.ApiId) || notificationsObj?.foldersIds?.includes(record.Identifier.ApiId);

        const handleActionFile = (event: number) => {
          // if (AccessPermission.isEngOrConsult() && (record.Status === 0) && openModalVisualizationBlockedFiles) {
          //   return openModalVisualizationBlockedFiles(false);
          // }
          if (record.IsFolder) {
            return openFolder(
              constructionSiteId,
              ConstructionSiteDisciplinesId,
              record.Identifier.ApiId,
              constructionSiteApiId,
              breadCrumbItem.BreadCrumbItemId || breadCrumbItem.BreadCrumbItemIdDropbox,
              false,
              record.Name,
              event,
              dispatch,
              navigate,
              disciplineName,
            );
          } else {
            return onOpenFile(record, event);
          }
        };

        const handleOpenLink = (): string | undefined => {
          // if (AccessPermission.isEngOrConsult() && (record.Status === 0) && openModalVisualizationBlockedFiles) {
          //   openModalVisualizationBlockedFiles(false);
          //   return;
          // }
          if (openLink.length > 0) {
            if (record.IsFolder) {
              return openLink;
            }
            if (record.RenderingStatus === 1 || (record.RenderingStatus === 2 && record.RenderingSignalR.etapa > 0)) {
              return openLink;
            }
            if (allOtherExtensions.indexOf(record.Extension.toLocaleLowerCase()) !== -1) {
              return openLink;
            }
            if (isCoordly2DViewerEligible(record.Extension)) {
              return openLink;
            }
            if (isCoordly3DViewerEligible(record.Extension, fileDataSizeToBytes(record))) {
              return openLink;
            }
          }
          return undefined;
        };

        return (
          <div
            className={styles['nameCollumn']}
            onContextMenu={(e) => onContextMenu(e, record)}
          >
            {(!record.UploadRenderingStatus || record.UploadRenderingStatus.archiveStatus === 'finishedSuccess') ? (
              <Icon
                color={record.HasInconsistencia ? 'vermelho' : (activeRow[0] === (record.Identifier.ApiId || record.Identifier.ItemId) ? 'primary' : 'cinzaPadrao')}
                icon={record.IsFolder
                  ? 'arquivar'
                  : iconFileByExtension(record.Extension)}
                customSize={18} />
            ) : (
              getSecondPlanUploadFiles(record.UploadRenderingStatus)
            )}
            <Tooltip overlay={
              record.FileInfo?.Description
                ? (<div className={styles['descriptionTooltip']} >
                  <div className={styles['iconWrap']}>
                    <Icon icon='informacao' customColor='#B3C0CE' customSize={17} />
                  </div>
                  {record.FileInfo.Description}
                </div>)
                : ''}
            >
              <a
                href={handleOpenLink()}
                onContextMenu={(e) => {
                  handleActionFile(e.button);
                }}
                onClick={(e) => {
                  handleActionFile(e.button);
                }}
                title={text}
                className={`${styles['name']} ${record.HasInconsistencia ? styles['hasInconsistencia'] : (activeRow[0] === (record.Identifier.ApiId || record.Identifier.ItemId) ? styles['nameActive'] : '')}`}
              >
                {text}
              </a>
            </Tooltip>
            {(!record.IsFolder && AccessPermission.editFiles(fileList, currentUserPrivileges) && !isObsoleteFolder) && (
              <Icon
                icon='editar'
                color='primary'
                className={`${styles['iconEditInList']} ${activeRow[0] === (record.Identifier.ApiId || record.Identifier.ItemId) ? styles['iconEditInListActive'] : ''}`}
                onClick={() =>
                  !AccessPermission.editFiles(fileList, currentUserPrivileges)
                    ? toastHandler.showError("Você não tem permissão para realizar esta ação. Solicite a permissão para seu coordenador ou administrador.")
                    : !isLoadingRenameFile
                      ? onChangeNomenclatureInList(record)
                      : undefined
                }
              />
            )}
            <span className={styles['iconVisualizarWrapper']}>
              {preferencesFeature && record?.IsFollow && (
                <Icon
                  icon='visualizar'
                  customSize={10}
                  className={styles['iconVisualizar']}
                />
              )}
              {hasNotification && (
                <DotNotification marginLeft={12} />
              )}
            </span>
          </div>
        );
      },
    },
    {
      dataIndex: 'Extension',
      className: `${styles['columnTipo']} ${preferencesFeature ? styles['columnTipoPointer'] : ''}`,
      title: (
        <ResizableColumnHeader
          columnId={RESIZABLE_COLUMN_IDS.Extension}
          title={'Tipo'}
          width={columnsWidth[RESIZABLE_COLUMN_IDS.Extension]}
          height={38}
          sorter={() => onSortList('extension')}
          orderTooltip={getOrderTitle(order.extension, 'extension')}
          showFilter={() => dispatch(ListagemArquivosActions.setShowFilterTipo(true))}
          onResize={onResize}
        />
      ),
      width: columnsWidth[RESIZABLE_COLUMN_IDS.Extension],
      onFilter: (value: any, record: any) => {
        if (!record.Extension) {
          return record;
        }

        return record.Extension?.toLowerCase() === value?.toLowerCase();
      },
      filterDropdown: (propsFilters: any) => {
        const showDataFilters = getFilterOptions(fileList, 'Extension', (x: string) => {
          if (!x) {
            return 'PASTA';
          }

          return x.trim().toLocaleUpperCase();
        });
        return <FilterModal
          propsFilter={propsFilters}
          tipoOptions={showDataFilters}
          showFilter={(visible: boolean) => dispatch(ListagemArquivosActions.setShowFilterTipo(visible))} />;
      },
      onFilterDropdownVisibleChange: (visible) => dispatch(ListagemArquivosActions.setShowFilterTipo(visible)),
      filterDropdownVisible: filters.showTipo,
      render: (text: string, record: any) => (
        <div
          className={styles['typeColumn']}
          onContextMenu={(e) => onContextMenu(e, record)}
        >
          {text ? text.toUpperCase() : '-'}
        </div>
      ),
    },
    {
      dataIndex: 'SizeInBytes',
      className: `${styles['columnTamanho']} ${preferencesFeature ? styles['columnTamanhoPointer'] : ''}`,
      title: (
        <ResizableColumnHeader
          columnId={RESIZABLE_COLUMN_IDS.SizeInBytes}
          title={'Tamanho'}
          width={columnsWidth[RESIZABLE_COLUMN_IDS.SizeInBytes]}
          height={38}
          sorter={() => onSortList('sizeInBytes')}
          orderTooltip={getOrderTitle(order.sizeInBytes, 'sizeInBytes')}
          onResize={onResize}
        />
      ),
      width: columnsWidth[RESIZABLE_COLUMN_IDS.SizeInBytes],
      render: (text: number, record: any) => (
        <div
          className={styles['sizeColumn']}
          onContextMenu={(e) => onContextMenu(e, record)}
        >
          {text ? sizeFileToInitials(fileDataSizeToBytes(record)) : '-'}
        </div>
      ),
    },
    {
      dataIndex: 'RenderingStatus',
      className: `${styles['columnVisualizacao']} ${preferencesFeature ? styles['columnVisualizacaoPointer'] : ''}`,
      title: (
        <ResizableColumnHeader
          columnId={RESIZABLE_COLUMN_IDS.RenderingStatus}
          title={'Visualização'}
          width={columnsWidth[RESIZABLE_COLUMN_IDS.RenderingStatus]}
          height={38}
          showOrder={false}
          onResize={onResize}
        />
      ),
      width: columnsWidth[RESIZABLE_COLUMN_IDS.RenderingStatus],
      render: (rederingStatus: number, record: any) => {
        return (
          <div
            className={styles['visualizationColumn']}
            onContextMenu={(e) => onContextMenu(e, record)}
          >
            <InfoRender
              status={rederingStatus}
              signalRender={record.RenderingSignalR}
              extension={record.Extension}
            />
          </div>
        );
      },
    },
    {
      dataIndex: 'Versions',
      className: `${styles['columnVersao']} ${preferencesFeature ? styles['columnVersaoPointer'] : ''}`,
      title: (
        <ResizableColumnHeader
          columnId={RESIZABLE_COLUMN_IDS.Versions}
          title={'Versão'}
          width={columnsWidth[RESIZABLE_COLUMN_IDS.Versions]}
          height={38}
          sorter={() => onSortList('revision')}
          orderTooltip={getOrderTitle(order.revision, 'revision')}
          showFilter={() => dispatch(ListagemArquivosActions.setShowVersions(true))}
          onResize={onResize}
        />
      ),
      width: columnsWidth[RESIZABLE_COLUMN_IDS.Versions],
      onFilter: (value: any, record: any) => (record.Revision === value.toLocaleUpperCase()),
      onFilterDropdownVisibleChange: (visible) => dispatch(ListagemArquivosActions.setShowVersions(visible)),
      filterDropdownVisible: filters.showVersions,
      filterDropdown: (propsFilters: any) => {
        const showDataFilters = getFilterOptions(fileList, 'Revision', (x: string) => x || '0');

        return <FilterModal
          propsFilter={propsFilters}
          tipoOptions={showDataFilters}
          showFilter={(visible: boolean) => dispatch(ListagemArquivosActions.setShowVersions(visible))} />;
      },
      render: (versions: any, record) => {
        const antIcon = (
          <LoadingOutlined style={{ color: '#3547C8', fontSize: 16, margin: '4px 0 6px 0' }} spin />
        );

        if (
          (versions && versions.length) ||
          (isLoadingFilesObsoleteList && record.HasNomenclatureControl)
        ) {
          let menu: React.ReactNode;

          if (isLoadingFilesObsoleteList) {
            menu = (
              <Menu className={styles['loadingVersionDropdownWrapper']}>
                <Menu.Item className={styles['loadingVersionDropdown']}>
                  <div>
                    <Spin indicator={antIcon} />
                  </div>
                  <div>
                    <span>Carregando versões...</span>
                  </div>
                </Menu.Item>
              </Menu>
            );
          } else {
            menu = (
              <Menu>
                <Menu.Item key="current" className={styles['currentVersionItem']}>
                  <span>{record.Revision || '-'}</span>
                  <span className={styles['currentVersionLabel']}>
                    {i18next.t('listagemArquivos:columns.currentVersion')}
                  </span>
                </Menu.Item>
                <Menu.Divider />
                {
                  // aqui faz o map para renderizar todas as versões do arquivo em tela
                  versions.map((version: any, index: number) => (
                    // TODO Implementar a função de abrir arquivo
                    <Menu.Item key={index}>
                      {version.Revision}
                    </Menu.Item>
                  ))
                }
              </Menu>
            );
          }

          return (
            <div
              className={styles['versionColumn']}
              onContextMenu={(e) => onContextMenu(e, record)}
            >
              <Dropdown overlay={menu as any} trigger={['click']} placement='bottomLeft'>
                <span style={{ display: 'flex' }} className={styles['versionSelect']} >
                  <span className={styles['revision']} >{record.Revision || '-'}</span>
                  <Icon
                    className={styles['versionSelectIcon']}
                    icon='setaOrdenarAsc'
                    color='cinzaPadrao'
                    customSize={8} />
                </span>
              </Dropdown>
            </div>
          );
        }

        return (
          <div
            className={styles['versionColumn']}
            onContextMenu={(e) => onContextMenu(e, record)}
          >
            <span className={styles['revision']} >{record.Revision || '-'}</span>
          </div>
        );
      },
    },
    {
      dataIndex: 'LastUpdate',
      className: `${styles['columnModificado']} ${preferencesFeature ? styles['columnModificadoPointer'] : ''}`,
      title: (
        <ResizableColumnHeader
          columnId={RESIZABLE_COLUMN_IDS.LastUpdate}
          title={'Modificado'}
          width={columnsWidth[RESIZABLE_COLUMN_IDS.LastUpdate]}
          height={38}
          sorter={() => onSortList('lastUpdate')}
          orderTooltip={getOrderTitle(order.lastUpdate, 'lastUpdate')}
          showFilter={() => dispatch(ListagemArquivosActions.setShowModificado(true, true))}
          onResize={onResize}
        />
      ),
      width: columnsWidth[RESIZABLE_COLUMN_IDS.LastUpdate],
      onFilter: (value: any, record: any) => {
        const lastUpdate = new Date(record.LastUpdate).toLocaleDateString();
        return (lastUpdate === value || record.ModifiedBy === value);
      },
      onFilterDropdownVisibleChange: (visible) => dispatch(ListagemArquivosActions.setShowModificado(visible, false)),
      filterDropdownVisible: filters.showModificado.show,
      filterDropdown: (propsFilters: any) => {
        if (filters.showModificado.showData) {
          const showDataFilters = getFilterOptions(fileList, 'LastUpdate', (v: any) => new Date(v).toLocaleDateString());

          return <FilterModal
            width='250px'
            propsFilter={propsFilters}
            tipoOptions={showDataFilters}
            showFilter={(visible: boolean) => dispatch(ListagemArquivosActions.setShowModificadoData(visible))}
          />;
        }

        if (filters.showModificado.showUsers) {
          const showUsersFilters = getFilterOptions(fileList, 'ModifiedBy', undefined, (index) => index !== '-', (updateIndex) => (
            <div className={styles['filterModificadoPor']}>
              <GetAvatar name={updateIndex} shape='circle' size='small' />
              {updateIndex}
            </div>
          ));

          return <FilterModal
            width='250px'
            propsFilter={propsFilters}
            tipoOptions={showUsersFilters}
            showFilter={(visible: boolean) => dispatch(ListagemArquivosActions.setShowModificadoUsers(visible))}
          />;
        }

        if (filters.showModificado.showDropdown) {
          return <Menu className={styles['menu-container']}>
            <Menu.Item onClick={() => dispatch(ListagemArquivosActions.setShowModificadoData(true))}>
              <div className={`ant-menu-submenu ant-menu-submenu-vertical ${styles['menu']}`} >
                <p className={styles['text']}>Filtrar por data</p>
                <div className={`ant-menu-submenu-title ${styles['icon']}`}>
                  <i className='ant-menu-submenu-arrow'></i>
                </div>
              </div>
            </Menu.Item>
            <Menu.Item onClick={() => dispatch(ListagemArquivosActions.setShowModificadoUsers(true))}>
              <div className={`ant-menu-submenu ant-menu-submenu-vertical ${styles['menu']}`} >
                <p className={styles['text']}>Filtrar por usuário</p>
                <div className={`ant-menu-submenu-title ${styles['icon']}`}>
                  <i className='ant-menu-submenu-arrow'></i>
                </div>
              </div>
            </Menu.Item>
          </Menu>;
        }

        return <></>;
      },
      render: (text: string, record: any) => {
        return (
          <Tooltip overlay={modifiedTooltip(text, record, onOpenHistoryDrawer)}>
            <span
              className={`${styles['modifiedDate']} ${preferencesFeature ? styles['modifiedDatePointer'] : ''}`}
              onContextMenu={(e) => onContextMenu(e, record)}
            >
              {dateToLocaleString(new Date(text))}
            </span>
          </Tooltip>
        );
      },
    },
    {
      dataIndex: 'Status',
      className: `${preferencesFeature ? styles['columnStatusPointer'] : styles['columnStatus']}`,
      title: (
        <ResizableColumnHeader
          columnId={RESIZABLE_COLUMN_IDS.Status}
          title={'Status'}
          width={columnsWidth[RESIZABLE_COLUMN_IDS.Status]}
          height={38}
          sorter={() => onSortList('status')}
          orderTooltip={getOrderTitle(order.status, 'status')}
          showFilter={() => dispatch(ListagemArquivosActions.setShowFilterStatus(true))}
          onResize={onResize}
        />
      ),
      width: columnsWidth[RESIZABLE_COLUMN_IDS.Status],
      onFilter: (value: any, record: any) => (record.Status !== null && record.Status.toString() === value),
      filterDropdown: (propsFilters: any) => {
        const showDataFilters = getFilterOptions(
          fileList,
          'Status',
          undefined,
          undefined,
          (x: number) => setTag(getFileStatusEnumLabel(i18next.t)[x], FileStatusEnumColor[x]));

        return <FilterModal
          hideSearch={true}
          propsFilter={propsFilters}
          tipoOptions={showDataFilters}
          showFilter={(visible: boolean) => dispatch(ListagemArquivosActions.setShowFilterStatus(visible))}
        />;
      },
      onFilterDropdownVisibleChange: (visible) => dispatch(ListagemArquivosActions.setShowFilterStatus(visible)),
      filterDropdownVisible: filters.showStatus,
      render: (status: number, record: any) => {
        status = status || 0;
        return (
          <div
            className={styles['statusColumn']}
            onContextMenu={(e) => onContextMenu(e, record)}
          >
            {record.IsFolder
              ? '-'
              : setTag(getFileStatusEnumLabel(i18next.t)[status], FileStatusEnumColor[status])}
          </div>
        );
      },
    },
    {
      dataIndex: 'Action',
      className: styles['columnAction'],
      title: (
        preferencesFeature ? (
          <ResizableColumnHeader
            columnId={RESIZABLE_COLUMN_IDS.Action}
            title={''}
            width={columnsWidth[RESIZABLE_COLUMN_IDS.Action]}
            height={38}
            showOrder={false}
            onResize={onResize}
          />
        ) : null
      ),
      width: columnsWidth[RESIZABLE_COLUMN_IDS.Action],
      render: (status: number, record: any) => {
        if (!preferencesFeature) { return null; }

        return (
          <span className={styles['actionColumn']}>
            <Popover
              open={openMoreActionsDropdown.open &&
                openMoreActionsDropdown.id === record.Identifier.ApiId}
              trigger='click'
              placement='left'
              className={styles['popoverMoreActions']}
              content={
                <MoreActionsDropdownContent
                  record={record}
                  folderId={folderId}
                  breadCrumbPreviousItemId={breadCrumbPreviousItemId}
                  onToggleContextMenuPreventClose={onToggleContextMenuPreventClose}
                  onOpenFile={onOpenFile}
                  onToggleFollowFolder={onToggleFollowFolder}
                  onDownloadFile={onDownloadFile}
                  onEditFile={onEditFile}
                  onChangeStatusFile={onChangeStatusFile}
                  onOpenHistoryDrawer={onOpenHistoryDrawer}
                  onOpenModalExclusaoArquivos={onOpenModalExclusaoArquivos}
                  onCloseMoreActionsDropdown={onCloseMoreActionsDropdown}
                />
              }
              onOpenChange={(open) => onOpenMoreActionsDropdown(record.Identifier.ApiId, open)}
              overlayInnerStyle={{ padding: 0 }}
            >
              <div className={styles['iconWrapper']}>
                <Icon icon='moreActions' className={styles['iconAction']} />
              </div>
            </Popover>
          </span>
        );
      },
    },
  ]);

export const getColumnsTableEdit: (input: IEditColumnsInput) =>
  Array<ColumnProps<any>> = ({ editFormIndex, onSubmit, isLoadingRenameFile, nomenclature, dispatch, obra, isStageValidation, constructionSiteDisciplinesId }) => ([{
    title: 'Nome',
    dataIndex: 'Name',
    render: (text, record, index) => {
      const toggleEditForm = () => {
        dispatch(ListagemArquivosActions.setEditFormIndex((index)));
      };

      return (
        <div className={styles['editColumnWrapper']} >
          <div onClick={() => !isLoadingRenameFile ? toggleEditForm() : undefined}
            className={`${styles['nameColumnEdit']} ${editFormIndex.includes((index)) ? styles['active'] : ''}`}>
            <Icon
              className={styles['iconFile']}
              color={record.HasInconsistencia ? 'vermelho' : 'cinzaPadrao'}
              icon={record.IsFolder
                ? 'arquivar'
                : iconFileByExtension(record.Extension)}
              customSize={18} />
            <span className={`${styles['name']} ${record.HasInconsistencia ? styles['hasInconsistencia'] : ''}`}>
              {text}
            </span>
            <Icon
              className={styles['iconEdit']}
              icon='editar'
            />
          </div>
          {(editFormIndex.includes((index))) && (
            <>
              {isStageValidation && (
                <NewEdicaoNomenclatura
                  record={record}
                  nomenclature={nomenclature}
                  obra={obra}
                  constructionSiteDisciplinesId={constructionSiteDisciplinesId}
                  onSubmit={onSubmit}
                  isLoadingRenameFile={isLoadingRenameFile}
                  text={text}
                  toggleEditForm={toggleEditForm}
                  index={index}
                />
              )}
              {!isStageValidation && (
                <EdicaoNomenclatura
                  record={record}
                  nomenclature={nomenclature}
                  obra={obra}
                  onSubmit={onSubmit}
                  isLoadingRenameFile={isLoadingRenameFile}
                  text={text}
                  toggleEditForm={toggleEditForm}
                  index={index}
                />
              )}
            </>
          )}
        </div>
      );
    },
  }]);

export const getColumnsRequestPlotTable:
  (input: IRequestPlotColumnsInput) => Array<ColumnProps<any>>
  = ({
    fileList,
    dispatch,
    deleteRow,
    onChangeQtyValue,
    onChangeHasColor,
    onChangeAllHasColor,
    onChangeShowQRCode,
    onChangeAllShowQRCode,
  }) => {
    return [
      {
        dataIndex: 'Name',
        title: 'Nome',
        className: styles['columnNome'],
        render: (text: string, record: any, index) => (
          <div className={styles['nameCollumn']}>
            <Field label='' type='hidden' name={`name${index}`} value={text} />
            <Icon
              color='cinzaPadrao'
              icon={iconFileByExtension(record.Extension)}
              customSize={18} />
            <span className={styles['name']} >
              {text}
            </span>
          </div>
        ),
      },
      {
        dataIndex: 'ShowQRCode',
        title: (
          <FieldReact name={`isQrCodeField`} type='checkbox'>
            {
              (propsField) => (
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <Checkbox
                    name={`isQrCode`}
                    checked={fileList.every((file) => {
                      return file.Extension?.toLowerCase() === 'pdf' && file.ShowQRCode;
                    })}
                    indeterminate={fileList.some((file) => {
                      return file.Extension?.toLowerCase() === 'pdf' && file.ShowQRCode;
                    }) && !fileList.every((file) => {
                      return file.Extension?.toLowerCase() === 'pdf' && file.ShowQRCode;
                    })}
                    onChange={onChangeAllShowQRCode}
                  >
                    <span>QR Code</span>
                  </Checkbox>
                  <InfoQRCodeDropdown />
                </span>
              )
            }
          </FieldReact>
        ),
        className: styles['columnCor'],
        render: (text, record, index) => (
          <FieldReact name={`isQrCodeField${index}`} type='checkbox' >
            {
              (propsField) => (
                <Tooltip
                  placement='topLeft'
                  overlay={
                    record?.Extension?.toLowerCase() !== 'pdf'
                      ? 'O rastreamento via QR Code só está disponível para PDF.'
                      : undefined
                  }
                >
                  <Checkbox className={styles['corColumn']}
                    name={`isQrCode${index}`}
                    onChange={onChangeShowQRCode}
                    checked={text}
                    disabled={record?.Extension?.toLowerCase() !== 'pdf'}
                  >
                    <span>Rastrear</span>
                  </Checkbox>
                </Tooltip>
              )
            }
          </FieldReact>
        ),
      },
      {
        dataIndex: 'QtyCopies',
        title: 'Cópias',
        className: styles['columnCopias'],
        render: (text, record, index) => (
          <div className={styles['qtyCopiesColumn']} >
            <Field
              className={`qtyCopies ${styles['qtyCopiesField']}`}
              controledInput
              value={text}
              placeholder='Quantidade'
              name={`QtyCopies${index}`}
              onInput={(e) => onChangeQtyValue(Math.abs(parseInt(e) || 0), index)}
              type='number'
              parse={(value) => Math.abs(parseInt(value) || 0)}
              label=''
            />
          </div>
        ),
      },
      {
        dataIndex: 'HasColor',
        title: (
          <FieldReact name={`isTermsAcceptedField`} type='checkbox'>
            {
              (propsField) => (
                <Checkbox
                  name={`isTermsAccepted`}
                  checked={fileList.every((file) => file.HasColor)}
                  indeterminate={fileList.some((file) => file.HasColor) &&
                    !fileList.every((file) => file.HasColor)
                  }
                  onChange={onChangeAllHasColor}
                >
                  <span>Cor</span>
                </Checkbox>)
            }
          </FieldReact>
        ),
        className: styles['columnCor'],
        render: (text, record, index) => (
          <FieldReact name={`isTermsAcceptedField${index}`} type='checkbox' >
            {
              (propsField) => (
                <Checkbox className={styles['corColumn']}
                  name={`isTermsAccepted${index}`}
                  onChange={onChangeHasColor}
                  checked={text}
                >
                  <span>Colorido</span>
                </Checkbox>)
            }
          </FieldReact>
        ),
      },
      {
        title: ' ',
        className: styles['columnExclui'],
        render: (text, record, index) => (
          <span className={styles['deletePlotRowButton']} onClick={() => deleteRow(index)}>
            <Icon icon='excluir' />
          </span>
        ),
      },
    ];
  };

export const getBreadCrumbDefault: (breadCrumbItem: IBreadCrumbItemResponse) =>
  IBreadcrumbItem[] = (breadCrumbItem) => {
    const breadCrumb: IBreadcrumbItem[] = [
      {
        href: '',
        isLoading: true,
      },
      {
        href: '',
        isLoading: true,
      },
    ];

    let nextBCI: IBreadCrumbItem | undefined = breadCrumbItem;
    const breadCrumbFolders = [];
    do {
      breadCrumbFolders.push({
        href: '',
        isLoading: true,
      });
      nextBCI = nextBCI.PreviousItem;
    } while (nextBCI);

    breadCrumb.push(...breadCrumbFolders.reverse());

    return breadCrumb;
  };

export const getBreadCrumb: (
  obra: IObraData,
  breadCrumbItem: IBreadCrumbItemResponse,
  constructionSiteDisciplinesId: number,
  isObsoleteFolder?: boolean,
) => IBreadcrumbItem[] = (
  obra,
  breadCrumbItem,
  constructionSiteDisciplinesId,
  isObsoleteFolder,
) => {
    const breadCrumb: IBreadcrumbItem[] = [
      {
        description: obra.Name,
        href: `/obras/detail/${obra.ConstructionSiteId}`,
      },
      {
        description: 'Arquivos',
        href: `/obras/detail/${obra.ConstructionSiteId}`,
      },
    ];

    let nextBCI: IBreadCrumbItem | undefined = breadCrumbItem;
    const breadCrumbFolders = [];
    do {
      breadCrumbFolders.push({
        description: nextBCI.Name,
        href: `/obras/filelist/${obra.ConstructionSiteId}/${nextBCI.Identifier}?obraApi=${obra.Api}${constructionSiteDisciplinesId ? `&ConstructionSiteDisciplinesId=${constructionSiteDisciplinesId}` : ''}${nextBCI.Name ? `&folderName=${nextBCI.Name}` : ''}${nextBCI.PreviousItem?.BreadCrumbItemId || nextBCI.PreviousItem?.BreadCrumbItemIdDropbox ? `&breadCrumbId=${nextBCI.PreviousItem?.BreadCrumbItemId || nextBCI.PreviousItem?.BreadCrumbItemIdDropbox}` : ''}`,
      });
      nextBCI = nextBCI.PreviousItem;
    } while (nextBCI);

    if (isObsoleteFolder) {
      breadCrumbFolders[0].href += `&isObsoleteFolder=${isObsoleteFolder}`;
    }

    breadCrumb.push(...breadCrumbFolders.reverse());
    return breadCrumb;
  };

const modifiedTooltip = (
  text: string,
  record: any,
  onOpenHistoryDrawer?: (fileData?: IFileData) => void,
) => (
  <div className={styles['tooltipModifiedBy']}>
    <div className={styles['title']}>
      Última atualização em
    </div>
    <div className={styles['value']}>
      {datetimeToString(new Date(text))}
    </div>
    {
      !record.ModifiedBy || record.ModifiedBy === '-'
        ? ''
        : (<>
          <div className={`${styles['title']} ${styles['margin-top']}`}>
            Realizada por
          </div>
          <div>
            <GetAvatar name={record.ModifiedBy} />
            <span className={`${styles['padding-left']} ${styles['value']}`}>
              {record.ModifiedBy}
            </span>
          </div>
        </>)
    }
    <Button
      type='text'
      className={styles['btnActionTooltip']}
      onClick={() => onOpenHistoryDrawer && onOpenHistoryDrawer(record)}
    >
      <Icon
        icon='history'
        customSize={18}
      />
      <span>Ver histórico</span>
    </Button>
  </div>
);
